import { render, staticRenderFns } from "./CompanySearch.vue?vue&type=template&id=1b8c8676&scoped=true"
import script from "./CompanySearch.vue?vue&type=script&lang=js"
export * from "./CompanySearch.vue?vue&type=script&lang=js"
import style0 from "./CompanySearch.vue?vue&type=style&index=0&id=1b8c8676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8c8676",
  null
  
)

export default component.exports